import React, { useEffect } from "react";
import "./ReviewsWidget.css";

const SCRIPT_SRC = "https://reputationhub.site/reputation/assets/review-widget.js";
const SCRIPT_FLAG = "__lc_reviews_widget_loaded__";

export default function ReviewsWidget({ widgetSrc, heading = "What Our Patients Say" }) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window[SCRIPT_FLAG]) return;
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      window[SCRIPT_FLAG] = true;
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.defer = true;
    document.body.appendChild(s);
    window[SCRIPT_FLAG] = true;
  }, []);

  if (!widgetSrc) return null;

  return (
    <section id="reviews" className="reviews-widget section-padding">
      <div className="container">
        <h2>{heading}</h2>
        <iframe
          className="lc_reviews_widget"
          src={widgetSrc}
          title="Patient Reviews"
          frameBorder="0"
          scrolling="no"
          style={{ minWidth: "100%", width: "100%" }}
        />
      </div>
    </section>
  );
}
